import { resolveCreatorStore, type CreatorStore } from '../../account/creatorStore';
import { saveStorage } from '../saveStorage';

/**
 * The Level Creator's store for whoever is playing (account when a session
 * exists, else this device — through `saveStorage()` so ?debug stays
 * sandboxed). Resolved per call: sign-in and sign-out reload the page anyway.
 */
export async function creatorStoreNow(): Promise<CreatorStore> {
  return (await resolveCreatorStore(saveStorage())).store;
}

/** True when levels are going to this device only (the menu says so). */
export async function creatorIsDeviceOnly(): Promise<boolean> {
  return (await resolveCreatorStore(saveStorage())).kind === 'device';
}
